import dayjs from 'dayjs';
/** AI独立解决率 */ export const CHART_COLORS = [
    '#FF9500',
    '#2EA7FF',
    '#5E77FF'
];
export const getLegendItems = (data, t)=>{
    const keys = [
        'c_a_reception_pure_intelligent',
        'c_a_reception_to_artificial',
        'c_a_reception_pure_manual'
    ];
    return keys.map((key, i)=>{
        var _data_i, _data_i1;
        return {
            name: t(key),
            color: CHART_COLORS[i],
            num: (data === null || data === void 0 ? void 0 : (_data_i = data[i]) === null || _data_i === void 0 ? void 0 : _data_i.num) ?? 0,
            percent: (data === null || data === void 0 ? void 0 : (_data_i1 = data[i]) === null || _data_i1 === void 0 ? void 0 : _data_i1.percent) ?? '0.00'
        };
    });
};
/** 店铺接待子会话量 */ export const getChartOption = (data, t)=>{
    const ai = (data === null || data === void 0 ? void 0 : data[0]) ?? {
        num: 0,
        percent: '0.00'
    };
    const transfer = (data === null || data === void 0 ? void 0 : data[1]) ?? {
        num: 0,
        percent: '0.00'
    };
    const human = (data === null || data === void 0 ? void 0 : data[2]) ?? {
        num: 0,
        percent: '0.00'
    };
    return {
        tooltip: {
            trigger: 'item',
            appendToBody: true,
            extraCssText: 'padding: 10px 16px; line-height: 2; white-space: nowrap;',
            formatter: (params)=>{
                return `${params.name}<br/>${params.value} (${params.data.backendPercent}%)`;
            }
        },
        series: [
            {
                type: 'pie',
                left: 0,
                right: 0,
                center: [
                    '50%',
                    '50%'
                ],
                radius: [
                    '40%',
                    '72%'
                ],
                avoidLabelOverlap: false,
                color: [
                    '#FF9500',
                    '#2EA7FF',
                    '#5E77FF'
                ],
                itemStyle: {
                    borderRadius: 2,
                    borderColor: '#fff',
                    borderWidth: 1
                },
                data: [
                    {
                        value: ai.num,
                        name: t('c_a_reception_pure_intelligent'),
                        backendPercent: ai.percent
                    },
                    {
                        value: transfer.num,
                        name: t('c_a_reception_to_artificial'),
                        backendPercent: transfer.percent
                    },
                    {
                        value: human.num,
                        name: t('c_a_reception_pure_manual'),
                        backendPercent: human.percent
                    }
                ],
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                },
                label: {
                    show: false
                },
                labelLine: {
                    show: false
                }
            }
        ]
    };
};
/** AI独立解决率 */ export const getTrendOption = function(list, name) {
    let areaColor = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '#FFF7E6', color = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : '#ffb72b';
    const safeList = list ?? [];
    return {
        tooltip: {
            trigger: 'axis',
            appendToBody: true,
            formatter: (params)=>{
                var _p_data;
                const p = params[0];
                const date = p === null || p === void 0 ? void 0 : (_p_data = p.data) === null || _p_data === void 0 ? void 0 : _p_data.create_date;
                return `<div>${date ? dayjs(date).format('YYYY-MM-DD') : ''}</div>
                        <div style="margin-top:6px;">
                            <span style="font-weight:500;">${name}：${(p === null || p === void 0 ? void 0 : p.value) ?? 0}%</span>
                        </div>`;
            }
        },
        grid: {
            top: 20,
            left: '7%',
            right: '4%',
            bottom: 3,
            containLabel: true
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: safeList.map((item)=>item.create_date),
            axisLabel: {
                color: '#333',
                show: false
            },
            splitLine: {
                show: false
            },
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            }
        },
        yAxis: {
            type: 'value',
            axisLabel: {
                color: '#333',
                show: false
            },
            splitLine: {
                show: false
            }
        },
        series: [
            {
                name,
                type: 'line',
                data: safeList.map((item)=>({
                        value: Math.round(Number(item.ai_independent_rate)),
                        create_date: item.create_date
                    })),
                color,
                smooth: true,
                lineStyle: {
                    width: 3
                },
                itemStyle: {
                    color,
                    symbol: 'none'
                },
                areaStyle: {
                    color: areaColor
                },
                emphasis: {
                    disabled: true
                }
            }
        ]
    };
};
